'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
  return {
    fields: {
      team: {
        label: 'Find a team to join',
        validators: [validators.required('Enter your team fundraising target')]
      }
    }
  };
};